import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useForm, SubmitHandler } from 'react-hook-form'
import { t } from 'i18next'

import { ReactComponent as Logo } from '../../assets/Logo.svg'
import { EmailPassFormInputs } from '../../types/EmailPassFormInputs'
import Button from '../../common/components/Button'
import Layout from '../../common/components/Layout'
import EmailInput from '../../common/components/Auth/EmailInput'
import PasswordInput from '../../common/components/Auth/PasswordInput'
import styles from './Login.module.css'
import { authenticateUser } from '../../common/utils/cognito'
import { useAuth } from '../../common/context/AuthContext'
import { useUserStore } from '../../store/user-store'

const LoginPage = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string>('')
  const navigate = useNavigate()
  const { fetchUser } = useUserStore()

  const { fetchOnboardingStatus, setIsAuthenticated } = useAuth()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<any>()

  const onSubmit: SubmitHandler<EmailPassFormInputs> = async (data) => {
    setIsLoading(true)
    setError('')
    try {
      await authenticateUser(data.email.toLowerCase(), data.password)
      await fetchUser()
      setIsAuthenticated(true)

      const isOnboardingComplete = await fetchOnboardingStatus()

      if (isOnboardingComplete) {
        navigate('/feed')
      } else {
        navigate('/question/1')
      }
    } catch (error) {
      setError(t('login.invalidCredentials'))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className={styles.loginContainer}>
      <div className={styles.backgroundImage}>
        <div className={styles.logoWrapper}>
          <Logo />
        </div>
      </div>
      <Layout containerStyle="inputContainer">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={styles.formContainer}
        >
          <EmailInput register={register} errors={errors} />
          <PasswordInput name="password" register={register} errors={errors} />
          <div className={styles.forgotPassword}>
            <Link to="/reset-password">
              <p>{t('login.forgotPassword')}</p>
            </Link>
          </div>
          <Button
            testId="loginBtn"
            title={t('login.logIn')}
            disabled={isLoading}
          />
          {error && <div className={styles.error}>{error}</div>}
        </form>
        {/* <div className={styles.continueWith}>
          <p>or continue with </p>
          <div className={styles.socialIcons}>
            <img src={InstagramIcon} alt="instagram" />
            <img src={GoogleIcon} alt="google" />
            <img src={AppleIcon} alt="apple" />
          </div>
        </div> */}
        <div className={styles.dontHaveAccountSign}>
          <p>{t('login.noAccount')}</p>
          <Link to="/signup">
            <p className={styles.signup}>{t('login.signUp')}</p>
          </Link>
        </div>
      </Layout>
    </div>
  )
}

export default LoginPage
